/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Search</h4>

<p>Search for a command. Just click and start typing.</p>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcut:</b></li>
    <li class='shortcuts__item'><b>Ctrl-F</b>: Search for a command</li>
</ul>`;

export default function SearchTooltip() {
    return h('div', { innerHTML: body });
}
